module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('section', {
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "logo-menu"
  }, [_c('nav', {
    staticClass: "navbar navbar-default affix-top navbar-border",
    attrs: {
      "role": "navigation",
      "data-spy": "affix",
      "data-offset-top": "50"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "drop"
  }, [_c('a', {
    attrs: {
      "href": '/'
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 2),
      expression: "mode==2"
    }],
    staticClass: "drop"
  }, [_c('a', {
    staticClass: "active",
    attrs: {
      "href": '/'
    }
  }, [_c('i', {
    staticClass: "fa fa-home fa-lg",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "drop"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\r\n                                    Buscar oferta\r\n                                ")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "drop"
  }, [_c('a', {
    attrs: {
      "href": '/ofertas/publicacion'
    }
  }, [_vm._v("\r\n                                    Publicar oferta\r\n                                ")])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }],
    staticClass: "drop"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("\r\n                                    Crear CV\r\n                                ")])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right float-right"
  }, [(!_vm.loginUser) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 1),
      expression: "mode==1"
    }]
  }, [_c('li', {
    staticClass: "right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-principal-head",
    on: {
      "click": function($event) {
        _vm.login(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" POSTULANTE")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm btn-principal-head",
    on: {
      "click": function($event) {
        _vm.login(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  EMPLEADOR")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "50px"
    }
  }, [_vm._v("\r\n                                    Inicia sesión o crea una cuenta\r\n                                ")])]) : _c('div', [(_vm.loginPostulante) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.user))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.closeSession()
      }
    }
  }, [_vm._v(" Cerrar sesión")])])])]) : (_vm.loginEmpleador) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.user))]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.closeSession()
      }
    }
  }, [_vm._v(" Cerrar sesión")])])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand logo",
    attrs: {
      "href": "index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logochev2.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mi escritorio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mis mensajes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Administrar tu cuenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-danger dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mi escritorio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mis mensajes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Administrar tu cuenta")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "wpb-mobile-menu"
  }, [_c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "active",
    attrs: {
      "href": "index.html"
    }
  }, [_vm._v("Home 1")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "index-02.html"
    }
  }, [_vm._v("Home 2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "index-03.html"
    }
  }, [_vm._v("Home 3")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "index-04.html"
    }
  }, [_vm._v("Home 4")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("Pages")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "about.html"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "job-page.html"
    }
  }, [_vm._v("Job Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "job-details.html"
    }
  }, [_vm._v("Job Details")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "resume.html"
    }
  }, [_vm._v("Resume Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "privacy-policy.html"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "faq.html"
    }
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "pricing.html"
    }
  }, [_vm._v("Pricing Tables")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "contact.html"
    }
  }, [_vm._v("Contact")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("For Candidates")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "browse-jobs.html"
    }
  }, [_vm._v("Browse Jobs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "browse-categories.html"
    }
  }, [_vm._v("Browse Categories")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "add-resume.html"
    }
  }, [_vm._v("Add Resume")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "manage-resumes.html"
    }
  }, [_vm._v("Manage Resumes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "job-alerts.html"
    }
  }, [_vm._v("Job Alerts")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("For Employers")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "post-job.html"
    }
  }, [_vm._v("Add Job")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "manage-jobs.html"
    }
  }, [_vm._v("Manage Jobs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "manage-applications.html"
    }
  }, [_vm._v("Manage Applications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "browse-resumes.html"
    }
  }, [_vm._v("Browse Resumes")])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "blog.html"
    }
  }, [_vm._v("Blog")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "blog.html"
    }
  }, [_vm._v("Blog - Right Sidebar")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "blog-left-sidebar.html"
    }
  }, [_vm._v("Blog - Left Sidebar")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "blog-full-width.html"
    }
  }, [_vm._v("Blog - Full Width")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "single-post.html"
    }
  }, [_vm._v("Blog Single Post")])])])]), _vm._v(" "), _c('li', {
    staticClass: "btn-m"
  }, [_c('a', {
    attrs: {
      "href": "post-job.html"
    }
  }, [_c('i', {
    staticClass: "ti-pencil-alt"
  }), _vm._v(" Publicar aviso")])]), _vm._v(" "), _c('li', {
    staticClass: "btn-m"
  }, [_c('a', {
    attrs: {
      "href": "my-account.html"
    }
  }, [_c('i', {
    staticClass: "ti-lock"
  }), _vm._v(" Ingresar a cuenta")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83811e02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/principal/HeaderMenu.vue
// module id = 658
// module chunks = 1